import { Button, Heading } from "@elaniintc/goes-design-system";
import { useNavigate, useRouteError } from "react-router";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import SiteLoadingIndicator from "@/components/site-loading-indicator";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { HeaderButtonProvider } from "@/contexts/header-button-context";

import { shouldReportErrorToSentry } from "@/utils/errors";

const ErrorPage = () => {
  const navigate = useNavigate();
  const error = useRouteError();

  const navigateHome = () => {
    navigate("/");
  };
  useEffect(() => {
    // Log error for debugging
    console.error("Route error occurred:", error);
    if (shouldReportErrorToSentry(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "240px",
          "--header-height": "60px",
        } as React.CSSProperties
      }
    >
      <SiteLoadingIndicator />
      <AppSidebar variant="inset" />
      <HeaderButtonProvider>
        <SidebarInset>
          <SiteHeader showBreadcrumbs={false} />
          <div className="h-full px-4 py-2 tablet:px-4 laptop:px-6 desktop:px-8 overflow-x-auto w-full">
            <div className="flex h-full w-full items-center justify-center">
              <div className="flex flex-col gap-8 justify-center max-w-130">
                <div className="flex flex-col gap-4">
                  <Heading variant="h2" className="text-center">
                    Error interno del servidor
                  </Heading>
                  <p className="text-body text-center">
                    Algo salió mal en nuestro servidor. Intenta de nuevo más
                    tarde o vuelve al inicio mientras lo solucionamos.
                  </p>
                </div>
                <Button variant="quiet" size="lg" onClick={navigateHome}>
                  Volver a inicio
                </Button>
              </div>
            </div>
          </div>
        </SidebarInset>
      </HeaderButtonProvider>
    </SidebarProvider>
  );
};

export { ErrorPage };
